<template>
  <Popper placement="right" :show="isPopperOpened">
    <button class="btn btn-warning btn-sm" @click="fetchData">
      <i class="fa-solid fa-pen-to-square"></i>
    </button>
    <template #content>
      <div>
        <div>
          <div class="d-flex align-items-center justify-content-between mb-2">
            <div class="fw-bold text-primary">
              Przepinka dla: {{ task.numer_Przejazdu }}
            </div>
            <button class="btn btn-sm btn-danger" @click="closePopper">
              Zamknij edytor <i class="fa-solid fa-xmark"></i>
            </button>
          </div>
        </div>
        <div class="form-floating">
          <input type="text" class="form-control" id="coOrdinatesInput" placeholder="50.123,50.123" v-model="latLngInput">
          <label for="coOrdinatesInput">Np. 52.4067,16.8430</label>
        </div>
        <span style="font-size:12px">np. 50.123,8.123</span>
        <div class="input-group mt-3">
          <span class="input-group-text">data i godzina</span>
          <input type="datetime-local" class="form-control" id="timeInput" v-model="currentChangeTime">
        </div>
        <div class="mt-3">
          <input type="text" placeholder="Znajdź ciągnik" class="form-control" v-model="vehiclesSearchText" @input="filterVehicles">
          <select name="vehicleSelect" id="vehicleSelect" class="form-control" v-model="currentVehicle.id">
            <option v-for="(vehicle, i) in filteredVehicles.length === 0 ? vehicles : filteredVehicles" :value="vehicle.id" :key="i">
              {{ vehicle.plateNumber }}
            </option>
          </select>
        </div>
        <div class="mt-3">
          <form @submit.prevent="attachDriver">
            <input type="text" placeholder="Znajdź kierowców" class="form-control" v-model="driversSearchText" @input="filterDrivers">
            <select name="driverSelect" id="driverSelect" class="form-control" v-model="selectedDriverId">
              <option v-for="(driver, index) in filteredDrivers.length === 0 ? drivers : filteredDrivers" :key="index" :value="driver.id" @focus="attachDriver(driver)">
                {{ driver.firstName }} {{ driver.surname }}
              </option>
            </select>
            <button class="btn btn-sm btn-success d-block w-100" type="submit">
              <i class="fa-solid fa-plus"></i> Dodaj kierowcę
            </button>
          </form>
        </div>
        <div class="mt-3">
          <div class="fw-bold">
            Aktualna lista kierowców:
          </div>
          <ul class="list-group drivers-list">
            <li class="list-group-item" v-for="(driver, index) in currentDrivers" :key="index" @click="removeDriver(index)">
              {{ driver.firstName }} {{ driver.surname }}
            </li>
          </ul>
        </div>
        <div>
          <button class="btn btn-success d-block w-100 mt-3" @click="submitChange">Zatwierdź</button>
        </div>
      </div>
    </template>
  </Popper>
</template>

<script>
import { defineComponent } from 'vue'
import { mapGetters } from 'vuex'
import emitter from '@/modules/events/emitter'
import Popper from 'vue3-popper'
import Swal from 'sweetalert2'
import { $axios } from '@/modules/http/axios'
import { validateDateTime } from '@/modules/change/changeDateTimeValidator'

export default defineComponent({
  name: 'ChangeEditor',
  components: { Popper },
  props: ['task', 'change'],
  data () {
    return {
      axiosConfig       : { headers: { Authorization: `Bearer ${localStorage.getItem('accessToken')}` } },
      months            : ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
      isPopperOpened    : false,
      filteredVehicles  : [],
      filteredDrivers   : [],
      vehiclesSearchText: '',
      driversSearchText : '',
      placesSearchText  : '',
      latLngInput       : `${this.change.latitude},${this.change.longitude}`,
      currentVehicle    : this.change.vehicle,
      currentChangeTime : this.change.date,
      currentDrivers    : this.change.drivers,
      selectedDriverId  : null,
      dataToPut: {
        trasa  : '',
        postoje: []
      }
    }
  },
  computed: {
    ...mapGetters({
      vehicles: 'getChangeEditorVehicles',
      drivers : 'getChangeEditorDrivers'
    })
  },
  created () {
    emitter.on('changeEditorOpened', e => {
      if (e.taskId !== this.task.id) {
        this.isOpened = false
      }
    })
  },
  methods: {
    fetchData () {
      this.openPopper()

      this.$store.dispatch('fetchChangeEditorVehicles')
      this.$store.dispatch('fetchChangeEditorDrivers')
    },

    filterVehicles () {
      if (this.vehiclesSearchText.length > 1) {
        this.filteredVehicles = this.vehicles.filter(vehicle => vehicle.plateNumber.toLowerCase().includes(this.vehiclesSearchText.toLowerCase()))
      }
    },

    filterDrivers () {
      if (this.driversSearchText.length > 1) {
        this.filteredDrivers = this.drivers.filter(driver => `${driver.firstName} ${driver.surname}`.toLowerCase().includes(this.driversSearchText.toLowerCase()))
      }
    },

    openPopper () {
      this.isPopperOpened = true
    },

    closePopper () {
      emitter.emit('changeEditorOpened', { taskId: this.task.id })
      this.isPopperOpened = false
    },

    attachDriver () {
      const newDriver = this.drivers.find(d => d.id === this.selectedDriverId)

      if (newDriver && !this.currentDrivers.includes(newDriver)) {
        this.currentDrivers.push(newDriver)
      }
    },

    removeDriver (index) {
      this.currentDrivers.splice(index, 1)
    },

    async submitChange () {
      let validatorData = validateDateTime(this.currentChangeTime, this.task, true)

      if (this.currentChangeTime === '' || this.latLngInput === '' || !this.currentVehicle || this.currentDrivers.length === 0) {
        await Swal.fire('Proszę uzupełnić wszystkie pola', 'Każde pole w edytorze Przepinki musi zostać uzupełnione', 'error')
      } else if (!this.latLngInput.includes(',') && !this.latLngInput.includes('N')) {
        await Swal.fire('Proszę rozdzielić współrzędne przecinkiem', 'Pole współrzędnych musi zawierać dwie współrzędne rozdzielone przecinkiem', 'error')
      } else if (!validatorData.isValid) {
        await Swal.fire(validatorData.errorMessage, '', 'error')
      } else {
        await this.deleteChange()

        let driversIds = []

        const latitude = this.latLngInput.split(',')[0].trim()
        const longitude = this.latLngInput.split(',')[1].trim()

        this.currentDrivers.map(x => driversIds.push(x.id))

        const postData = {
          acronym: `P${this.currentVehicle.id}`,
          latitude: latitude,
          longitude: longitude,
          date: this.currentChangeTime,
          vehicleId: this.currentVehicle.id,
          driverIds: driversIds
        }

        try {
          const response = (await $axios.post(`${this.task.id}/Changes`, postData)).data
          await Swal.fire(`Zaktualizowano Przepinkę dla zlecenia ${this.task.numer_Przejazdu}`, '', 'success')

          emitter.emit('taskChanged', { taskId: this.task.id })
          if (response.relatedTaskId) { emitter.emit('taskChanged', { taskId: response.relatedTaskId }) }
        } catch (e) {
          await Swal.fire('Nie udało się zaktualizować danych Przepinki', `System nie był w stanie zaktualizować przepinki dla zlecenia ${this.task.numer_Przejazdu}. <br> <span class="fw-bold">Kod błędu: ${e.response?.status}</span>`, 'error')
        } finally {
          this.closePopper()
        }
      }
    },

    async deleteChange () {
      try {
        const response = (await $axios.delete(`${this.task.id}/Changes/${this.change.id}`)).data
        emitter.emit('taskChanged', { taskId: this.task.id })
        if (response.relatedTaskId) { emitter.emit('taskChanged', { taskId: response.relatedTaskId }) }
      } catch (e) {
        await Swal.fire('Nie udało się zaktualizować danych Przepinki', `System nie był w stanie zaktualizować w pełni Przepinki. <br> <span class="fw-bold">Kod błędu: ${e.response?.status}</span>`, 'error')
        console.log(e)
      }
    }
  }
})
</script>

<style scoped>
.drivers-list > li:hover{
  text-decoration: line-through;
  font-style: italic;
  cursor: pointer;
}
</style>
